import moment from 'moment'
import { Linking } from 'react-native'

export interface OpeningHours {
  day: string
  open: string
  isToday: boolean
}

/**
 * Format the opening hours to the following format:
 * [
 *  {
 *    day: 'Monday',
 *    open: '10:00',
 *    isToday: false
 *  },
 *  ...
 * ]
 * @param openingHours - The opening hours to format eg: ['Monday: 10:00 - 18:00', 'Tuesday: Closed']
 * @returns The formatted opening hours
 */
export const formatOpeningHours = (openingHours?: string[]): OpeningHours[] => {
  if (!openingHours) {
    return []
  }

  const today = moment().format('dddd').toLowerCase()

  return openingHours.map((day) => {
    const colonIndex = day.indexOf(':')
    const dayName = day.slice(0, colonIndex)
    const open = day.slice(colonIndex + 1)

    const isToday = dayName.toLowerCase() === today
    return {
      day: dayName,
      open,
      isToday,
    }
  })
}

export const handleLink = async (link: string) => {
  if (await Linking.canOpenURL(link)) {
    await Linking.openURL(link)
  }
}
